// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__23n5Z","footer":"Form_footer__1Mpg9"};